import type { IconName } from "@similarweb/icons";
import type { ButtonType } from "@similarweb/ui-components";

export type ButtonConfigSchema = {
    label: string;
    type: ButtonType;
    iconName: IconName;
    iconSize: string;
    tooltipEnabled: boolean;
    isDisabled: boolean;
    onClick: () => void;
    isLoading: boolean;
};

export enum ButtonsAlignVariant {
    End = "end",
    SpaceBetween = "space-between",
}
